import { MDBBtn, MDBCol, MDBIcon, MDBRow } from 'mdb-react-ui-kit'
import React from 'react'
import ScrollTo from "react-scroll-into-view";
import { motion } from "framer-motion";

const SectionFour = ({sectionId, sectionSelector}) => {
  return (
    <MDBRow id={sectionId} className="row d-flex justify-content-center align-items-center section-bg-black section-full-frame">
        <MDBCol className="col-sm-12 text-center d-flex flex-column justify-content-center align-items-center align-self-stretch mb-0 black p-5">
              <span className="section-font-color">TURPIS BIBENDUM</span>
              <motion.div initial={{ opacity: 0, y:-200 }} whileInView={{  opacity: 1, y:0 }}  transition={{ delay: 0.25 }} >
                  <h3 className="display-3 font-weight-bold my-4 text-white">"PORTTITOR NEQUE ALIQUAM <br /> VESTIBULUM MORBI. SAPIEN NEC <br /> SAGITTIS  ALIQUAM BIBENDUM ARCU."</h3>
              </motion.div>
              <ScrollTo selector={sectionSelector}>
                  <MDBBtn rounded className="p-3 my-4 d-flex justify-content-center align-items-center section-btn section-bg-yellow">
                    <h5 className="text-black mt-2 ms-3">CONSEQUAT</h5> 
                    <MDBIcon fas icon="arrow-right" size='2x' className="text-black ms-3 me-4"/>
                  </MDBBtn>
              </ScrollTo> 
          </MDBCol>
      </MDBRow>
  )
}

export default SectionFour